import BaseComponent from 'scripts/BaseComponent.js';
import axios from 'axios';

export default class ProductFormNotifyMe extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      successMessage: '.js-notify-me-success',
      errorMessage: '.js-notify-me-error',
      emailWrapper: '.js-notify-me-email-wrapper',
      disclaimer: '.js-notify-me-disclaimer',
      productForm: '.js-productForm',
      productSubmitBtn: '.ProductForm__submit',
      threekitUnavailable: '.js-threekitUnavailable',
    };

    this.dom = {
      $component: component,
      $emailWrapper: this.$get(this.refs.emailWrapper),
      $disclaimer: this.$get(this.refs.disclaimer),
      $successMessage: this.$get(this.refs.successMessage),
      $productForm: document.querySelector(this.refs.productForm),
      $productSubmitBtn: document.querySelector(this.refs.productSubmitBtn),
      $threekitUnavailability: document.querySelector(this.refs.threekitUnavailable),
    };

    this.state = {};

    this.mount();
  }

  mount() {
    const { dom } = this;
    super.mount();
    this.setOnSubmit(dom.$component, this.submitHandler);
    this.checkCustomizerAvailability();
  }

  checkCustomizerAvailability() {
    const { dom } = this;
    if (dom.$threekitUnavailability) {
      const threekitUnavailable = JSON.parse(dom.$threekitUnavailability.innerHTML);
      if (threekitUnavailable) {
        dom.$component.removeAttribute('hidden');
      }
    }
  }

  submitHandler() {
    const { dom } = this;
    const { method } = dom.$component;
    const variant = dom.$component.querySelector('[name="variant"]').value;
    const platform = dom.$component.querySelector('[name="platform"]').value;
    const email = dom.$component.querySelector('[name="email"]').value;

    const options = {
      method,
      url: 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=NuyS2s',
      headers: {
        accept: 'application/json',
        revision: '2024-05-15',
        'content-type': 'application/json',
      },
      data: {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email } } },
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: `$${platform}:::$default:::${variant}` } },
          },
        },
      },
    };

    axios
      .request(options)
      .then(() => {
        dom.$component.classList.add('submitted');
        dom.$successMessage.classList.add('is-active');
      })
      .catch((error) => {
        console.error(error);
        dom.$errorMessage.classList.add('is-active');
      });
  }
}
